import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-home-features-section',
  templateUrl: './home-features-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeFeaturesSectionComponent {}

